export default __webpack_public_path__ + "static/media/imgLight4.10d389ee.png";